<template>
  <div class="case-container" ref="wrapper" :class="{current:!loading}">
    <div class="case-subcontainer">
      <div class="grid-wrapper" ref="wrapper">
        <div class="grid-container">
          <div class="case-grid">
            <div class="grid-item" v-for="(brand,name,index) in brands" :key="index">
              <div class="grid-main" @click="openDialog(name)">
                <div class="brand">
                  <img :src="resources[brand.logo.default].src"/>
                </div>
                <div class="brand-cover">
                  <img :src="resources[brand.logo.active].src"/>
                </div>
              </div>
              <div class="top-icon icon">
                <div class="icon-plus"></div>
              </div>
              <div class="bottom-icon icon">
                <div class="icon-plus"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <transition name="fade" v-on:before-leave="dialogLeaverBefore" v-on:enter="dialogEnter">
      <div class="dialog" v-if="brandItems.length">
        <div class="dialog-container" ref="wrapper2">
          <div class="waterfall" :class="{float:brandItems.length <=2}">
            <img @click="openLightBox(item,$event)" :src="resources[item.thumb].src" v-for="(item, index) in brandItems" :key="index" />
          </div>
        </div>
        <img @load="loadImage" :src="resources['casesBtnBack'].src" class="btn-back" @click="closeDiaog"/>
      </div>
    </transition>

    <transition name="fade">
      <LightBox :closed.sync="closed" class="light-box" :data="data" >
        <template v-slot:left="{scope}">
          <div class="slide-main">
            <div class="slide-head">{{scope.title}}</div>
            <div class="slide-content">{{scope.desc}}</div>
            <div class="icon-plus"></div>
          </div>
        </template>
        <template v-slot:close>
          <img @click="closeLightBox" :src="resources['trainingDialogBtnClose'].src" class="btn-close"/>
        </template>
      </LightBox>
    </transition>
  </div>
</template>
<script>
import {cloneDeepWith} from "loadsh";
import brands from "../api/cases.js";
import LightBox from  "../components/LightBox.vue";
import Bscroll from '@better-scroll/core'
import MouseWheel from '@better-scroll/mouse-wheel'
Bscroll.use(MouseWheel)
console.log(brands);
export default {
  name:'Cases',
  components:{
    LightBox
  },
  data(){
    return {
      brands:[],
      brandItems:[],
      resources:null,
      index:4,
      data: {},
      closed:true,
      loading:true,
      dialogScroll:null,
      loaded:0

    }
  },

  created(){
    this.$store.dispatch('changeTheme',"white");
    this.resources = this.$store.state.resources;
    this.brands = brands;
    
    
  },
  mounted(){
    
    this.$nextTick(()=>{
      this.loading = false;
      this.scroll = new Bscroll(this.$refs.wrapper, {
        mouseWheel:true,
        probeType:3,
        disableMouse:false,
        tap:false,
        click:false,
        bounce: {
          top:false
        }
      });
      
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('changeTheme','');
    this.loading = true;
    next();
  },
  methods:{
    loadImage(){
      this.loaded++;
      if(this.loaded >= this.brandItems.length && this.dialogScroll){
        this.dialogScroll.refresh();
        console.log('刷新');
      }
    },
    dialogLeaverBefore(){
       this.dialogScroll.destroy();
       this.dialogScroll = null;
    },
    dialogEnter(){
      if(this.dialogScroll) {
        this.dialogScroll.refresh();
      }else {
        this.dialogScroll = new Bscroll(this.$refs.wrapper2, {
          mouseWheel:true,
          probeType:3,
          disableMouse:false,
          tap:true,
          click:true,
          bounce: {
            top:false
          }
        });
        
      }
    },
    closeDiaog(){
      this.$store.dispatch('changeTheme','white');
      this.brandItems = [];
    },
    
    openDialog(name){
      let items = brands[name].works,{resources} = this,self = this;
      if(items.length){
        this.loadObj = this.$loading({
          text:'页面加载中...',
          target:document.querySelector('.case-container')
        });
        let loaded = 0 ,total = items.length;
        for(var i = 0 ,len = items.length ; i < len ; i++){
          (function(i){
            var image = new Image();
            image.onload = function(){
              this.onload = null;
              // console.log(resources[items[i].thumb].src+':'+'加载完成');
              loaded++;
              if(loaded >= total){
                self.$store.dispatch('changeTheme','');
                self.brandItems = items;
                self.loadObj.close()
              }
            }
            image.src = resources[items[i].thumb].src;


          })(i)
        }
        


      }      
    },
    closeLightBox(){
      this.closed = true;
    },
    openLightBox(item,event){
      if(!item.zpic.length) {
        return ;
      }
      


      this.data = item;
      this.closed = false;
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";
  @import "../common/theme.scss";
  .case-container {
    background-color: $themeColor;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: px2rem(112);
      top: 0;
      left: 0;
      background-color: $themeColor;
    }
    &.current {
      .grid-item {
        @for $v from 1 to 30 {
          &:nth-child(#{$v}){
            animation: fadeIn 1s .1s * $v ease forwards;
          }
        }
      }
    }
  }
  .case-subcontainer {
    padding:  px2rem(142) 0 40px;
  }
  @keyframes fadeIn {

    100%{
      opacity: 1;
      transform: none;
    }
  }
  .case-grid {
    width: 980px;
    position: relative;
    margin: auto;
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .grid-item {
    margin-bottom: 20px;
    float: left;
    width: 180px;
    height: 180px;
    font-size:14px;
    box-shadow: inset px2rem(4) px2rem(4) px2rem(4) rgba(#b10f0c, .72);
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    transform: translate3d(0,100%,0);
    opacity: 0;
    &:not(:nth-child(5n+1)){
      margin-left: 20px;
    }
    .icon {
      width: 0;
      height: 0;
      position: absolute;
      &:after ,
      &:before{
        content: "";
        position: absolute;
      }
      &:after {
        width: px2rem(71);
        border-top: 1px dashed #fff;
        opacity: 0;
      }
      &:before {
        opacity: 0;
        height: px2rem(71);
        border-left: 1px dashed #fff;
      }
    }
    $distance: 150%;
    $scale:.2;
    .top-icon {
      left: px2rem(-17);
      top: px2rem(-17);
      &:after {
        left: 16px;
        top: 1px;
        transform-origin: right center;
        transform:  translate3d($distance,0,0) scaleX($scale);
      }
      &:before {
        top: 16px;
        left: 1px;
        transform-origin: bottom center;
        transform: translate3d(0,$distance,0) scaleY($scale);
      }
    }
    .bottom-icon {
      right: px2rem(-17);
      bottom: px2rem(-17);
      &:after {
        right: 13px;
        top: 1px;
        transform-origin: left center;
        transform: translate3d(-1 * $distance,0,0) scaleX($scale);;
      }
      &:before {
        bottom: 13px;
        left: 1px;
        transform-origin: top center;
        transform: translate3d(0,-1 * $distance,0) scaleY($scale);
      }
    }

    .grid-main,
    .brand,
    .brand-cover {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        max-width: 80%;
      }
      
    }
    $ratio:210/200;
    .brand-cover {
      background: #fff;
      transition: all .3s linear;
      opacity: 0;
    }
    &:hover {
      .brand-cover {
        opacity: 1;
        transform: scale($ratio);
      }
      .icon-plus {
        animation: icon_anim .7s .4s linear forwards;
      }
      .icon:after ,
      .icon:before {
        opacity: 1;
        transition: all 1s  linear;
        transform: none;
      }
      
    }
  }
  .dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #fff;
    padding: px2rem(122) 0 0;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 20;
  }
  .btn-back {
    position: absolute;
    right: 0;
    top: 122px;
    cursor: pointer;
  }
  .waterfall {
    font-size: 0;
    width: 100%;
    cursor: pointer;
    display: block;
    column-count: 5;
    column-gap: px2rem(30);
    &.float {
      img {
        float: left;
        + img {
          margin-left: 20px;
        }
      }
    }
    img {
      flex-grow: 0;
      flex-shrink: 0;
      width: 100%;
      margin-left: 0;
      margin-bottom: px2rem(40);
    }
    
  }

  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
  .fade-enter,.fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active , .fade-leave-active {
    transition: all 1s;
  }

  .dialog-container {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 0 132px 0 166px;
    overflow: hidden;
    
  }
  .slide-main {
    height: 100%;
    overflow: auto;
    padding: 0 0 0 px2rem(25);
    .slide-head {
      font-size: px2rem(24);
    }
    .slide-content {
      font-size: 12px;
      margin-top: px2rem(10);
      line-height: 1.5;
      text-align: justify;
    }
    &:after {
      content: "";
      width: px2rem(2);
      height: 70%;
      position: absolute;
      left: px2rem(9);
      background: #fff;
      top: px2rem(30);
      transform: scaleY(0);
      transform-origin: top center;
    }
  }
  
  .icon-plus {
    width: 0;
    height: 0;
    top:0;
    left: 0;
    position: absolute;

    .slide-main & {
      padding: px2rem(10);
    }
    transform:scale(0);
    &:after,
    &:before {
      content:"";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%,-50%,0);
      background: #fff;
    }
    $width: px2rem(20);
    $height: px2rem(2);
    &:after {
      width: $width;
      height: $height;
    }
    &:before {
      width: $height;
      height: $width;
    }
  }
  
  .light-box /deep/ .swiper-slide-active {
    .slide-main:after {
      transform: none;
      transition:  all .5s .45s ease;
    }
    .icon-plus {
      animation: icon_anim .9s ease forwards;
    }

  }
  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
  .btn-close {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  
  /deep/ .el-loading-spinner {
    .path {
      stroke: $themeColor!important;
    }
    .el-loading-text{
      color:$themeColor!important
    }
  }
</style>
